export default "__VITE_PUBLIC_ASSET__470855bb__"